import { db } from './../config/Fire';
import * as Constants from './../constants/nodes_database';

export const SET_PROMOTIONS_PER_DAY_RESTAURANT_USER = 'SET_PROMOTIONS_PER_DAY_RESTAURANT_USER';
export const SAVING_RESTAURANT = 'SAVING_RESTAURANT';
export const SAVED_RESTAURANT = 'SAVED_RESTAURANT';

const setPromotionsPerDayRestaurantUser = payload => ({ type: SET_PROMOTIONS_PER_DAY_RESTAURANT_USER, payload });
export const setSavingRestaurant = payload => ({ type: SAVING_RESTAURANT, payload });
export const setSavedRestaurant = payload => ({ type: SAVED_RESTAURANT, payload });

export const setPromotionsPerDayToRestaurant = payload => {
    return dispatch => {
        var isSavingRestaurant = true;
        dispatch(setSavingRestaurant(isSavingRestaurant));
        const { id, promotionsPerDay } = payload;
        if(id) {
            return db.ref(`${Constants.RESTAURANTS}/${id}`).update({
                promotionsPerDay
            })
            .then(() => {
                dispatch(setPromotionsPerDayRestaurantUser(payload));
                dispatch(setSavingRestaurant(isSavingRestaurant = false));
                var isSavedRestaurant = true;
                dispatch(setSavedRestaurant(isSavedRestaurant));
            })
            .catch(err => {
                console.log("not found save data");
                dispatch(setSavingRestaurant(isSavingRestaurant= false));
            });
        } else {
            console.log("id undefined: ");
            dispatch(setSavingRestaurant(isSavingRestaurant= false));
        }
    };
};